import { Avatar } from 'antd'

import { getProjectAvatarColor, getProjectInitials } from 'modules/dao-voting/utils'

/**
 * Project avatar: PTO thumbnail when available, otherwise a colored square
 * with 2-letter initials (mockup style).
 */
const ProjectAvatar = ({
  name,
  src,
  size = 40,
}: {
  name: string
  src?: string | null
  size?: number
}) => {
  if (src) {
    return <Avatar shape="square" size={size} src={src} style={{ borderRadius: 8 }} />
  }
  return (
    <Avatar
      shape="square"
      size={size}
      style={{
        backgroundColor: getProjectAvatarColor(name),
        fontWeight: 600,
        borderRadius: 8,
      }}
    >
      {getProjectInitials(name)}
    </Avatar>
  )
}

export default ProjectAvatar
